import {
  Typography as MuiTypography,
  TypographyProps as MuiTypographyProps,
} from "@mui/material"

export interface TypographyProps extends MuiTypographyProps {
  active?: boolean
}

export const Typography = (props: TypographyProps) => {
  const { variant = "body1", active = false, sx, ...others } = props
  return (
    <MuiTypography
      data-testid="testTypography"
      variant={variant}
      sx={{
        ...(active && {
          borderBottom: "2px solid",
          borderColor: "primary.main",
        }),
        ...sx,
      }}
      {...others}
    >
      {props.children}
    </MuiTypography>
  )
}
